import $ from 'jquery'
import Base from 'luminate/src/modules/base'
import { isIE, dependency } from '../utilities'
import mapStyle from './map/style'

const Map = Base.extend({
	directive: 'map',

	defaults: {
		apiKey: '',
		lat: 0,
		lng: 0,
		zoom: 0,
		marker: false,
		control: false,
		title: ''
	},

	modules: {

		markers: Base.extend({
			directive: 'marker',

			defaults: {
				lat: 0,
				lng: 0,
				title: false,
				url: false
			}
		})
	},

	events: {

		init: function()
		{
			const apiUrl = 'https://maps.googleapis.com/maps/api/js?key=' + this.$settings.apiKey

			// Convert the zoom to an integer so Google doesn't complain
			this.$settings.zoom = this.$settings.zoom|0

			dependency(apiUrl, () =>
			{
				const MapLabel = require('./map/label').default
				const point = new google.maps.LatLng(this.$settings.lat, this.$settings.lng)

				this.map = new google.maps.Map(this.$element, {
					center: point,
					zoom: this.$settings.zoom,
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					scrollwheel: false,
					streetViewControl: false,
					draggable: this.$settings.control,
					panControl: false,
					overviewMapControl: false,
					zoomControl: this.$settings.control,
					mapTypeControl: false,
					disableDefaultUI: true,
					disableDoubleClickZoom: true,
					styles: mapStyle
				})

				this.mapMarkerInfos = []

				for(let marker of this.$owns.markers)
				{
					const markerSettings = marker.$settings
					const markerPoint = new google.maps.LatLng(markerSettings.lat, markerSettings.lng)
					const mapMarker = new google.maps.Marker({
						map: this.map,
						position: markerPoint,
						title: markerSettings.title || ''
					})

					if(markerSettings.url)
					{
						mapMarker.addListener('click', e => window.open(markerSettings.url, '_blank'))
					}
					else
					{
						const markerInfo = new google.maps.InfoWindow({
							content: marker.$element.innerHTML
						})

						this.mapMarkerInfos.push(markerInfo)

						mapMarker.addListener('click', e =>
						{
							for(let info of this.mapMarkerInfos)
							{
								info.close()
							}

							markerInfo.open(this.map, mapMarker)
						})
					}

					if(this.$settings.marker && !isIE())
					{
						mapMarker.setIcon(this.$settings.marker)
					}

					if(marker.$element.nodeName.toLowerCase() === 'a')
					{
						google.maps.event.addListener(mapMarker, 'click', function()
						{
							window.location.href = marker.$element.getAttribute('href')
						})
					}

					var label = new MapLabel({map: this.map})
					label.bindTo('position', mapMarker, 'position')
					label.bindTo('text', mapMarker, 'title')
				}

				$(window).on('resize', e =>
				{
					this.map.setCenter(point)
					this.map.setZoom(this.$settings.zoom)

					this.autoZoom()
				})

				google.maps.event.addListenerOnce(this.map, 'idle', () => this.autoZoom())
			},
			() => window.google && google.maps)
		}
	},

	methods: {

		autoZoom()
		{
			let containsAllMarkers = true

			const mapBounds = this.map.getBounds()
			const bounds = new google.maps.LatLngBounds()

			for(let marker of this.$owns.markers)
			{
				let markerPoint = new google.maps.LatLng(marker.$settings.lat, marker.$settings.lng)

				containsAllMarkers = containsAllMarkers && mapBounds.contains(markerPoint)
				bounds.extend(markerPoint)
			}

			if(!containsAllMarkers)
			{
				this.map.fitBounds(bounds)

				if(this.$settings.zoom && this.map.getZoom() > this.$settings.zoom)
				{
					this.map.setZoom(this.$settings.zoom)
				}
			}
		}
	}
})

export default Map



// WEBPACK FOOTER //
// ./source/scripts/modules/map.js